type Callback = () => any

export class TryLater {
  private registry: Callback[] = []

  register(cb: Callback) {
    const result = cb()
    if (result !== TryLater.OK) {
      this.registry.push(cb)
    }
  }

  attempt() {
    this.registry = this.registry.filter((cb) => cb() !== TryLater.OK)
  }

  static OK = {}
}
